import moment from 'moment';
export class DashboardParams {
    fromDate? = moment().startOf('month').valueOf();
    toDate? = moment().endOf('month').valueOf();
}